import { render, staticRenderFns } from "./RegionBordersSettingList.vue?vue&type=template&id=fdadb226&scoped=true&"
import script from "./RegionBordersSettingList.vue?vue&type=script&lang=js&"
export * from "./RegionBordersSettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdadb226",
  null
  
)

export default component.exports